import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { MainService } from '@api/custom-services/main.service';
import { UserService } from '@api/custom-services/user.service';
import { Authority } from '@api/models';
import { CustomerDto } from '@api/models/customer-dto';
import { environment } from '@env/environment';
import { SideBarComponent } from '@shared/components/side-bar/side-bar.component';
import { MenuItems } from '@shared/constants/menu';
import { HasAuthoritiesDirective } from '@shared/directives/has-authorities.directive';
import { SubscriptionDirective } from '@shared/directives/subscriptions.directive';
import { LocalCashRegisterService } from '@shared/services/cash-register.service';
import { map } from 'rxjs';

@Component({
   selector: 'app-dashboard',
   imports: [
      CommonModule,
      ReactiveFormsModule,
      RouterOutlet,
      RouterModule,
      SideBarComponent,
      MatSidenavModule,
      MatToolbarModule,
      MatMenuModule,
      MatButtonModule,
      MatListModule,
      MatIconModule,
      MatButtonToggleModule,
      HasAuthoritiesDirective,
   ],
   templateUrl: './dashboard.component.html',
   styleUrl: './dashboard.component.scss',
})
export class DashboardComponent extends SubscriptionDirective {
   protected readonly Authority = Authority;

   @ViewChild(MatSidenav)
   sidenav!: MatSidenav;

   public isCollapsed = localStorage.getItem('sidebar-open') === 'yes';
   public isMobile = true;
   public list: any[] = [];

   public user$ = this.userService.user$;
   public userInitials$ = this.user$.pipe(map((user) => user.firstName.charAt(0)));
   public topbarTemplate$ = this.mainService.topbarTemplate$;

   constructor(
      private observer: BreakpointObserver,
      private router: Router,
      private userService: UserService,
      private mainService: MainService,
      private localCashRegisterService: LocalCashRegisterService
   ) {
      super();

      this.subs = this.observer.observe(['(max-width: 800px)']).subscribe((screenSize: { matches: any }) => {
         this.isMobile = screenSize.matches;
      });

      this.subs = this.userService.user$.subscribe(() => {
         this.list = MenuItems.filter((item) => this.userService.hasAccessToMenuItem(item));
      });
   }

   async toggleMenu() {
      if (this.isMobile) {
         this.sidenav.toggle().then();
         this.isCollapsed = false;
      } else {
         this.sidenav.open().then();
         this.isCollapsed = !this.isCollapsed;
      }

      localStorage.setItem('sidebar-open', this.isCollapsed ? 'yes' : 'no');
   }

   openLocalCashRegisterSettings() {
      this.localCashRegisterService.openRegisterSettings();
   }

   async onCustomerSelected(customer: CustomerDto) {
      await this.router.navigate(['/customer', customer.id, 'view']);
   }

   async onLogout() {
      await this.userService.logout();
   }

   protected readonly environment = environment;
}
